import { Directive, ElementRef, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Guid, Utility } from 'src/app/core/common';

@Directive({
  selector: '[share]',
  host: { '(click)': 'doShare()' }
})
export class ShareDirective {
  id = Guid.newGuid();
  constructor(private element: ElementRef<HTMLElement>, private toastr: ToastrService) { }

  @Input() share: string;
  doShare() {
    if (navigator.share)
      navigator.share({ url: this.share }).catch(() => {
        if (Utility.setClipboard(this.share))
          this.toastr.success('اطلاعات جهت اشتراک گذاری در حافظه موقت کپی شد');
      });
    else Utility.setClipboard(this.share);

  }
  ngOnInit() {
  }
}
